import {
  Avatar,
  Box,
  Button,
  Heading,
  HStack,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useDisclosure,
  VStack,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { useData } from "../../../Contexts/DataContext";
import AddEditRequirementModal from "../../ManageRequirements/AddEditRequirementModal";
import ViewTaskModal from "../../ManageRequirements/Tasks/ViewTaskModal";
import ConfirmDialog from "../../Shared/ConfirmDialog";
import { CheckIcon, ViewIcon } from "@chakra-ui/icons";

const TaskTable = ({
  tasks = [],
  maxH = "48vh",
  showOpenCompletedToggle = true,
  user = null,
}) => {
  const [selectedRequirement, setSelectedRequirement] = useState(null);
  const [selectedTask, setSelectedTask] = useState(null);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [taskToConfirm, setTaskToConfirm] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [sortField, setSortField] = useState("displayDate");
  const [sortDirection, setSortDirection] = useState("asc");
  const [showCompleted, setShowCompleted] = useState(false);

  const { updateDocument } = useData();

    const {
    isOpen: isViewModalOpen,
    onOpen: onViewModalOpen,
    onClose: onViewModalClose,
  } = useDisclosure();

  const {
    isOpen: isViewTaskModalOpen,
    onOpen: onViewTaskModalOpen,
    onClose: onViewTaskModalClose,
  } = useDisclosure();

  console.log("tasks", tasks);

  const handleToggleTaskCompletion = (task, newValue) => {
    setTaskToConfirm({
      id: task.id,
      newValue,
      name: task.name,
    });
    setShowConfirmDialog(true);
  };

  const handleOpenRequirement = (task) => {
    const formatted = {
      taskId: task.id,
      id: task.requirementId,
      title: task.requirementName,
      assignedTo: task.assignedTo || "",
      deliverableId: task.deliverableId || "",
      detail: task.detail || "",
      screenshots: [],
      dueDate: task.dueDate || "",
      status: task.status || "Not Started",
      linked_email: task.linked_email || "",
    };
    setSelectedRequirement(formatted);

    onViewModalOpen();
  };

  const today = new Date().toISOString();

  const completedTasks = tasks
    .filter((task) => task.completed)
    .map((task) => {
      const fallbackDate =
        task.dueDate && task.dueDate < today ? task.dueDate : today;
      return {
        ...task,
        displayDate: (task.modifiedOn || fallbackDate)?.split("T")[0] || "—",
      };
    });

  const openTasks = tasks
    .filter((task) => !task.completed)
    .map((task) => ({
      ...task,
      displayDate: task.dueDate?.split("T")[0] || "—",
    }));

  const sortedTasks = [...(showCompleted ? completedTasks : openTasks)].sort(
    (a, b) => {
      if (!sortField) return 0;
      const aValue = a[sortField] || "";
      const bValue = b[sortField] || "";

      if (typeof aValue === "string" && typeof bValue === "string") {
        return sortDirection === "asc"
          ? aValue.localeCompare(bValue)
          : bValue.localeCompare(aValue);
      }

      return sortDirection === "asc" ? aValue - bValue : bValue - aValue;
    }
  );

  const handleSort = (field) => {
    if (sortField === field) {
      setSortDirection((prev) => (prev === "asc" ? "desc" : "asc"));
    } else {
      setSortField(field);
      setSortDirection("asc");
    }
  };

  return (
    <Box overflowX="auto" mb={2}>
      <HStack justify="space-between" mb={2}>
        <Heading size="sm" color="black">
          {showCompleted ? "Completed Tasks" : "Open Tasks"} {user && `for ${user}`}  
        </Heading>
        {showOpenCompletedToggle && (
          <Button size="sm" onClick={() => setShowCompleted(!showCompleted)}>
            {showCompleted ? "View Open Tasks" : "View Completed Tasks"}
          </Button>
        )}
      </HStack>

      {sortedTasks.length > 0 ? (
        <TableContainer
          maxH={maxH}
          overflowY={"auto"}
          borderColor={"gray.300"}
          borderRadius={"md"}
          borderWidth={1}
          mb={6}
        >
          <Table variant="simple" colorScheme="gray">
            <Thead py={1}>
              <Tr py={1} bg="#1b193e">
                <Th
                  py={1}
                  color="white"
                  cursor="pointer"
                  onClick={() => handleSort("name")}
                >
                  Task{" "}
                  {sortField === "name" &&
                    (sortDirection === "asc" ? "▲" : "▼")}
                </Th>
                <Th
                  py={1}
                  color="white"
                  cursor="pointer"
                  onClick={() => handleSort("requirementName")}
                >
                  Requirement | Deliverable{" "}
                  {sortField === "requirementName" &&
                    (sortDirection === "asc" ? "▲" : "▼")}
                </Th>
                <Th
                  py={1}
                  color="white"
                  cursor="pointer"
                  onClick={() => handleSort("assignedTo")}
                >
                  Assigned to{" "}
                  {sortField === "assignedTo" &&
                    (sortDirection === "asc" ? "▲" : "▼")}
                </Th>
                <Th
                  py={1}
                  color="white"
                  cursor="pointer"
                  onClick={() => handleSort("displayDate")}
                >
                  {!showCompleted ? "Target" : "Date"}
                  {sortField === "displayDate" &&
                    (sortDirection === "asc" ? "▲" : "▼")}
                </Th>

                {/* <Th color={"white"}>Created</Th> */}
                <Th py={1} color={"white"} textAlign="center">
                  Actions
                </Th>
              </Tr>
            </Thead>
            <Tbody fontSize={"sm"} bg="white">
              {sortedTasks.map((task) => (
                <Tr
                  key={task.id}
                  _hover={{ bg: "gray.50" }}
                  onClick={() => {
                    setSelectedTask(task);
                    onViewTaskModalOpen();
                  }}
                  cursor={"pointer"}
                >
                  <Td>{task.name}</Td>

                  <Td>
                    <VStack align={"start"}>
                      <Text>{task.requirementName || "—"}</Text>
                      <Text color={"gray.400"}>
                        {task.deliverableName || "—"}
                      </Text>
                    </VStack>
                  </Td>

                  <Td>
                    <HStack spacing={2}>
                      <Avatar
                        name={task.assignedTo || "Not Assigned"}
                        src={task.assignedTo}
                        size="sm"
                      />
                      <VStack spacing={0} align="start">
                        <Text fontSize="sm">
                          {task.assignedTo || "Not Assigned"}
                        </Text>
                      </VStack>
                    </HStack>
                  </Td>
                  <Td>{task.displayDate}</Td>
                  {/* <Td>
                    {task.createdOn
                      ? new Date(task.createdOn).toLocaleString()
                      : "—"}
                  </Td> */}
                  <Td textAlign="center">
                    <HStack justify="center">
                      {!showCompleted && (
                        <Button
                          leftIcon={<CheckIcon />}
                          size="xs"
                          variant="outline"
                          colorScheme="green"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleToggleTaskCompletion(task, true);
                          }}
                        >
                          Mark Complete
                        </Button>
                      )}

                      <Button
                        leftIcon={<ViewIcon />}
                        size="xs"
                        variant="outline"
                        colorScheme="blue"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleOpenRequirement(task);
                        }}
                      >
                        View Requirement
                      </Button>
                    </HStack>
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </TableContainer>
      ) : (
        <Text fontSize="sm" color="gray.500">
          No tasks found.
        </Text>
      )}

      {isViewModalOpen && (
        <AddEditRequirementModal
          isOpen={isViewModalOpen}
          onClose={onViewModalClose}
          requirement={selectedRequirement}
          type={null}
          initialTabIndex={1}
        />
      )}

      {isViewTaskModalOpen && selectedTask && (
        <ViewTaskModal
          task={selectedTask}
          isOpen={isViewTaskModalOpen}
          onClose={() => {
            setSelectedTask(null);
            onViewTaskModalClose();
          }}
        />
      )}
      <ConfirmDialog
        isOpen={showConfirmDialog}
        onClose={() => setShowConfirmDialog(false)}
        onConfirm={async () => {
          if (taskToConfirm) {
            setIsSubmitting(true);
            try {
              await updateDocument("tasks", taskToConfirm.id, {
                completed: taskToConfirm.newValue,
                modifiedOn: new Date().toISOString(),
              });
            } catch (err) {
              console.error("Error marking complete:", err);
            } finally {
              setIsSubmitting(false);
              setShowConfirmDialog(false);
              setTaskToConfirm(null);
            }
          }
        }}
        title="Mark Task as Complete"
        body={`Are you sure you want to mark "${taskToConfirm?.name}" as complete?`}
        confirmText="Mark Complete"
        confirmColorScheme="green"
        cancelText="Cancel"
        isLoading={isSubmitting}
      />
    </Box>
  );
};

export default TaskTable;
